<rh-card *ngIf="result">
  <ng-container body-title>
    <p class="ui-label-l-bold text-low-contrast">
      <span class="cursor-pointer" (click)="openContent()">{{result.title}}</span>
    </p>
  </ng-container>
  <ng-container body-description>
    <p class="ui-component-text-m text-low-contrast">
      {{result.description}}
    </p>
  </ng-container>
  <ng-container footer>
    <p class="ui-component-text-s text-low-contrast">
      <a [href]="result.url">{{result.displayUrl}}</a>
    </p>
    <button rds-icon-button *ngIf="!isInQuickLinks"  (click)="addQuicklink()" [disabled]="blocked === true">
    <rds-icon  class="result__button" icon="add_circle" namespace="outlined"></rds-icon>
    </button>
    <button rds-icon-button *ngIf="isInQuickLinks"   [disabled]="blocked === true">
    <rds-icon class="result__button result__button--inactive" icon="checkmark_circle"  namespace="filled"></rds-icon>
    </button>
  </ng-container>
</rh-card>
